import { Component, OnInit } from '@angular/core';
import { FormGroup, Validators, FormBuilder } from '../../../../../../node_modules/@angular/forms';
import { UsuariosService } from '../../usuarios/usuarios.service';
import { Router } from '../../../../../../node_modules/@angular/router';
import { NotificacionesService } from '../../../../core/notificaciones/notificaciones.service';

@Component({
  selector: 'fuse-cambiar-password',
  templateUrl: './cambiar-password.component.html',
  styleUrls: ['./cambiar-password.component.scss']
})
export class CambiarPasswordComponent implements OnInit {

  cambiarPassForm: FormGroup;

  constructor(
    private formBuilder: FormBuilder,
    private usuariosService: UsuariosService,
    private router: Router,
    private notificaciones: NotificacionesService
  ) { }

  ngOnInit() {
    this.cambiarPassForm = this.formBuilder.group({
      pass: ['', Validators.required],
      newPass: ['', Validators.required]
    });
  }

  get pass() { return this.cambiarPassForm.get('pass').value; }
  get newPass() { return this.cambiarPassForm.get('newPass').value; }

  cambiarPass() {
    const pass = this.cambiarPassForm.value.newPass; 
    this.usuariosService.cambiarPassword(pass).subscribe(
      data => {
        if (data.success) {          
          this.router.navigate(['/perfil']);
          this.notificaciones.mostrarAviso(this.notificaciones.mensajes.IdiomaActual.Perfil.PassCambiada);
        } else {
          this.notificaciones.mostrarAviso(this.notificaciones.mensajes.IdiomaActual.Perfil.PassIgual);
        }
      },      
      err => this.notificaciones.mostrarAviso(this.notificaciones.mensajes.IdiomaActual.MensajesGenerales.ErrorDesconocido)
    );
    
  }

}



// WEBPACK FOOTER //
// ./src/app/main/content/perfil-usuario/cambiar-password/cambiar-password.component.ts